export const NAMESPACE = {
  COMMON_WITH_VARIABLES: "CommonWithVariables",
} as const;

export const CONTEXT_SEPARATOR = "___" as const;
export type CONTEXT_SEPARATOR = typeof CONTEXT_SEPARATOR;
